import { BackArrow } from 'assets/icons';
import Title from 'components/atoms/Title';
import HeaderBackButton from 'components/molecules/HeaderBackButton';
import { useConfig } from 'context/app-config';
import useOrderStep from 'packages/shared/newOrder/hooks/useOrderStep';
import { selectHasSelectedPreferences, selectSelectedServices } from 'pages/newOrder/newOrder.selectors';
import { useCustomerPreferences } from 'pages/queries/user.queries';
import React, { useCallback } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import withPageViewAnalytics from 'utils/hoc/withPageViewAnalytics';

import OrderFooter from '../../components/OrderFooter';
import OrderInstructionsOptions from './OrderInstructionsOptions';

const StyledBackButton = styled.button`
  style: none;
  background: ${({ theme }) => theme.components.onboardingBottomSheet.button.backgroundColor};
  border: ${({ theme }) =>
    `${theme.components.onboardingBottomSheet.button.border.width}px solid ${theme.components.onboardingBottomSheet.button.border.color}`};
  border-radius: 40px;
  height: 48px;
  padding: 0 25px;
  margin-right: 10px;
`;

const StyledDiv = styled.div<{ isStandAlone?: boolean }>`
  margin-top: ${({ isStandAlone }) => (isStandAlone ? '0px' : '16px')};
  margin-bottom: 80px;
`;

interface Props {
  isStandAlone?: boolean;
}

const OrderInstructions: React.FC<Props> = ({ isStandAlone }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const config = useConfig();

  const hasSupportForMultipleDropoffs = config?.modules.newOrder.dropoffs?.hasSupportForMultipleDropoffs;
  const selectedServiceLines = useSelector(selectSelectedServices);
  const hasPreferencesSelected = useSelector(selectHasSelectedPreferences);
  const { incrementStep } = useOrderStep();

  useCustomerPreferences();

  const handleGoBackOrIncrementStep = useCallback(() => (isStandAlone ? navigate(-1) : incrementStep()), [navigate, incrementStep, isStandAlone]);

  const buttonTextCode = hasPreferencesSelected ? 'common.continueOrSave' : 'common.skip';

  const onBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <StyledDiv isStandAlone={isStandAlone} className="pb-8">
      <Row>
        <Col>
          {config?.showBackButton && config.hideHeader && !config.showNewHeaderbackButton && <HeaderBackButton />}
          <Title>{t('common.orderInstructions')}</Title>
        </Col>
      </Row>
      {hasSupportForMultipleDropoffs ? (
        selectedServiceLines.map((serviceLine) => <OrderInstructionsOptions serviceLine={serviceLine} />)
      ) : (
        <OrderInstructionsOptions />
      )}

      <OrderFooter
        showBackgroundColor
        primaryButtonText={t(buttonTextCode)}
        onClick={handleGoBackOrIncrementStep}
        hidePriceButton={!config?.showPricingButtonOnInstructionsFooter}
        leftComponent={
          !config?.showPricingButtonOnInstructionsFooter ? (
            <StyledBackButton onClick={onBack}>
              <BackArrow />
            </StyledBackButton>
          ) : undefined
        }
      />
    </StyledDiv>
  );
};

export default withPageViewAnalytics<Props>({ pageName: 'OrderInstructions' })(OrderInstructions);
